/* assets/product-registration.js */
(function () {
    // =========================================================
    // Helpers
    // =========================================================
    function qs(id) {
        return document.getElementById(id);
    }
    function toBool(v) {
        return v === true || v === "true" || v === "1";
    }
    function str(v) {
        return v == null ? "" : String(v);
    }

    function escapeHtmlGlobal(s) {
        return String(s == null ? "" : s)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function scrollToTopSmooth() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function restoreAddressDefaults() {
        const countryEl = qs("AddressCountry");
        const provinceEl = qs("AddressProvince");
        if (!countryEl) return;

        const defaultCountry = countryEl.getAttribute("data-default") || "United States";
        const defaultProvince = provinceEl ? (provinceEl.getAttribute("data-default") || "") : "";

        // Set default country
        countryEl.value = defaultCountry;
        countryEl.dispatchEvent(new Event("change"));

        // Province will be repopulated by Shopify; apply default after it repopulates
        if (provinceEl) {
            setTimeout(() => {
                if (!provinceEl.disabled && defaultProvince) {
                    provinceEl.value = defaultProvince;
                }
            }, 0);
        }
    }

    // =========================================================
    // reCAPTCHA (callback available immediately)
    // =========================================================
    window.prRecaptchaWidgetId = window.prRecaptchaWidgetId ?? null;
    window.__prRecaptchaApiReady = false;

    window.prRecaptchaOnload = function () {
        window.__prRecaptchaApiReady = true;
        tryRenderRecaptcha();
    };

    function tryRenderRecaptcha() {
        const root = qs("pr-root");
        const el = qs("pr-recaptcha");
        if (!root || !el) return;

        const enabled = toBool(root.dataset.recaptchaEnabled);
        const sitekey = root.dataset.recaptchaSitekey || "";
        if (!enabled || !sitekey) return;

        if (!window.grecaptcha || !window.__prRecaptchaApiReady) return;

        try {
            if (window.prRecaptchaWidgetId == null) {
                window.prRecaptchaWidgetId = window.grecaptcha.render(el, { sitekey });
            }
        } catch (e) {
            console.log("reCAPTCHA render error", e);
        }
    }

    // =========================================================
    // Init entrypoint (normal + theme editor)
    // =========================================================
    function init() {
        const root = qs("pr-root");
        if (!root) return;

        // prevent double-init
        if (root.dataset.initialized === "true") return;
        root.dataset.initialized = "true";

        const endpoint = root.dataset.endpoint || "/apps/wss/product-registration";
        const shopDomain = root.dataset.shop || "";
        const recaptchaEnabled = toBool(root.dataset.recaptchaEnabled);
        const recaptchaSitekey = root.dataset.recaptchaSitekey || "";
        const defaultPurchaseLocation = root.dataset.defaultPurchaseLocation || "";

        initNewsletter();
        initAddressSelector();
        initPurchaseDateLimit();
        initClientIp();
        initAccountState();

        // Autocomplete
        const modelEnabled = toBool(root.dataset.modelSearchEnabled);
        if (modelEnabled) initModelAutocomplete(root);

        // Render recaptcha if api already loaded
        tryRenderRecaptcha();

        // Submit
        initFormSubmit({
            endpoint,
            shopDomain,
            recaptchaEnabled,
            recaptchaSitekey,
            defaultPurchaseLocation,
        });
    }

    document.addEventListener("DOMContentLoaded", init);

    // Shopify theme editor section reload support
    document.addEventListener("shopify:section:load", function () {
        const root = qs("pr-root");
        if (root) root.dataset.initialized = "false";
        init();
    });

    // =========================================================
    // Account state -> locked email / phone
    // =========================================================
    function initAccountState() {
        syncAccountState();
        window.addEventListener("pageshow", function (e) {
            if (e.persisted) syncAccountState();
        });
    }

    function syncAccountState() {
        const form = qs("product-registration-form");
        if (!form || !window.fetch) return;

        const url = location.pathname + "?sections=wss_account_state";
        fetch(url, { cache: "no-store", credentials: "same-origin", headers: { Accept: "application/json" } })
            .then(function (res) { return res.ok ? res.json() : null; })
            .then(function (data) {
                const html = data && data.wss_account_state;
                if (!html) return;
                const doc = new DOMParser().parseFromString(html, "text/html");
                const node = doc.getElementById("wss-account-state");
                if (!node) return;
                const state = JSON.parse(node.textContent || "{}");
                const signedIn = state.signedIn === true;
                lockAccountField(form.querySelector('input[name="email"]'), signedIn ? str(state.email) : "");
                lockAccountField(form.querySelector('input[name="phone"]'), signedIn ? str(state.phone) : "");
            })
            .catch(function () {});
    }

    function lockAccountField(input, value) {
        if (!input) return;
        if (value) {
            if (input.value !== value) input.value = value;
            input.setAttribute("value", value);
            input.readOnly = true;
            input.setAttribute("aria-readonly", "true");
        } else if (input.readOnly) {
            input.readOnly = false;
            input.removeAttribute("aria-readonly");
            input.removeAttribute("value");
            input.value = "";
        }
    }

    // =========================================================
    // Newsletter checkbox -> hidden input
    // =========================================================
    function initNewsletter() {
        const checkbox = qs("newsletterCheckbox");
        const hiddenInput = qs("newsletterValue");
        if (!checkbox || !hiddenInput) return;

        const update = () => (hiddenInput.value = checkbox.checked ? "1" : "0");
        update();
        checkbox.addEventListener("change", update);
    }

    // =========================================================
    // Address selector defaults
    // =========================================================
    function initAddressSelector() {
        const countryEl = qs("AddressCountry");
        const provinceEl = qs("AddressProvince");
        if (!countryEl || !provinceEl) return;

        // Helper: does the selected country have provinces?
        function countryHasProvinces() {
            const opt = countryEl.options[countryEl.selectedIndex];
            const raw = opt ? opt.getAttribute("data-provinces") : null;
            if (!raw) return false;
            // Shopify renders [] when none exist
            return raw !== "[]";
        }

        // Helper: toggle province select required/disabled safely
        function syncProvinceState() {
            const has = countryHasProvinces();

            // Always keep the element visible (optional)
            provinceEl.style.display = "";

            if (!has) {
                // No provinces → make it non-required and disabled
                provinceEl.innerHTML = `<option value="">N/A</option>`;
                provinceEl.disabled = true;
                provinceEl.removeAttribute("required");
            } else {
                // Provinces exist → enable + required
                provinceEl.disabled = false;
                provinceEl.setAttribute("required", "required");
                // NOTE: Shopify selector will populate options automatically
            }
        }

        // If Shopify helper is missing, exit (your earlier issue)
        if (!(window.Shopify && Shopify.CountryProvinceSelector)) return;

        try {
            const defaultCountry = countryEl.getAttribute("data-default") || "United States";
            const defaultProvince = provinceEl.getAttribute("data-default") || "";

            //  Init selector first (important)
            new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
                hideElement: null,
            });

            //  Set default country AFTER init, then trigger change
            if (defaultCountry) {
                countryEl.value = defaultCountry;
                countryEl.dispatchEvent(new Event("change"));
            }

            // Province toggling based on selected country
            // Run after Shopify populates provinces
            setTimeout(() => {
                syncProvinceState();

                //  Default province (only if provinces exist)
                if (defaultProvince && !provinceEl.disabled) {
                    provinceEl.value = defaultProvince;
                }
            }, 0);

            // When country changes, Shopify repopulates province list → re-sync required/disabled
            countryEl.addEventListener("change", () => {
                setTimeout(syncProvinceState, 0);
            });

        } catch (e) {
            console.log("Address selector init error", e);
        }
    }

    // =========================================================
    // Client IP (fetch real IP so the server doesn't log proxy IP)
    // =========================================================
    // A purchase cannot have happened yet. Set the ceiling at page load rather
    // than in Liquid, so a cached page cannot leave the limit a day behind.
    function initPurchaseDateLimit() {
        var el = document.getElementById("pr-purchase-date");
        if (!el) return;
        el.max = new Date().toISOString().slice(0, 10);
    }

    function initClientIp() {
        var el = qs("pr-ip-address");
        if (!el) return;
        fetch("https://api.ipify.org?format=json")
            .then(function (res) { return res.json(); })
            .then(function (data) { if (data && data.ip) el.value = data.ip; })
            .catch(function () { /* silent – server falls back to headers */ });
    }

    // =========================================================
    // Form submit
    // =========================================================
    function initFormSubmit(cfg) {
        const form = qs("product-registration-form");
        const submitBtn = qs("pr-submit-btn");
        const alertErr = qs("pr-alert-error");
        const alertOk = qs("pr-alert-success");
        const loadingBox = qs("pr-loading");
        if (!form || !submitBtn || !alertErr || !alertOk || !loadingBox) return;

        function showError(msg) {
            alertErr.textContent = msg;
            alertErr.style.display = "block";
            alertOk.style.display = "none";
        }

        function showSuccess(msg) {
            alertErr.style.display = "none";
            alertOk.style.display = "none";
            form.style.display = "none";

            var wrapper = form.closest(".pr-wrapper");

            // Hide header, subtitle, and "All fields required"
            if (wrapper) {
                var header = wrapper.querySelector(".pr-header");
                if (header) header.style.display = "none";
                var allReq = wrapper.querySelector(".pr-all-required");
                if (allReq) allReq.style.display = "none";
            }

            var existing = document.getElementById("pr-success-card");
            if (existing) existing.remove();

            var card = document.createElement("div");
            card.id = "pr-success-card";
            // Styled by product-registration.css (#pr-success-card rules),
            // which this page already loads.
            card.innerHTML =
                '<div class="review-wrapper">' +
                    '<div class="review-header-success">Your product is now registered!</div>' +
                    '<div class="review-body">' +
                        '<p>' + escapeHtmlGlobal(msg || 'Your product has been registered and its warranty is now active.') + '</p>' +
                        '<a href="/">START SHOPPING</a> | <a href="/pages/recipes">EXPLORE RECIPES</a>' +
                    '</div>' +
                '</div>';

            if (wrapper) {
                wrapper.appendChild(card);
            } else {
                form.parentNode.insertBefore(card, form.nextSibling);
            }
        }

        function setLoading(isLoading) {
            submitBtn.disabled = !!isLoading;
            loadingBox.style.display = isLoading ? "flex" : "none";
        }

        function resetRecaptcha() {
            if (!cfg.recaptchaEnabled) return;
            if (!window.grecaptcha) return;
            if (window.prRecaptchaWidgetId == null) return;
            try { window.grecaptcha.reset(window.prRecaptchaWidgetId); } catch (_) {}
        }

        function validate(formEl) {
            let valid = true;
            const requiredFields = formEl.querySelectorAll(".pr-input[required], .pr-select[required]");

            requiredFields.forEach((field) => {
                const wrapper = field.closest(".pr-field");
                const errorEl = wrapper ? wrapper.querySelector(".pr-error") : null;

                field.classList.remove("pr-invalid");
                if (errorEl) errorEl.style.display = "none";

                if (!field.value || String(field.value).trim() === "") {
                    valid = false;
                    field.classList.add("pr-invalid");
                    if (errorEl) errorEl.style.display = "block";
                }
            });

            const email = formEl.querySelector('input[name="email"]');
            if (email && email.value && !/^\S+@\S+\.\S+$/.test(email.value)) {
                valid = false;
                email.classList.add("pr-invalid");
                const wrapper = email.closest(".pr-field");
                const errorEl = wrapper ? wrapper.querySelector(".pr-error") : null;
                if (errorEl) {
                    errorEl.textContent = "Please enter a valid email address.";
                    errorEl.style.display = "block";
                }
            }

            return valid;
        }

        async function readJsonSafely(res) {
            const txt = await res.text().catch(() => "");
            if (!txt) return {};
            try { return JSON.parse(txt); } catch (_) { return {}; }
        }

        // Opens the Bazaarvoice review form after a successful registration.
        //
        // BV reads its bvaction/bvproductId parameters when it initialises.
        // Adding them to the URL afterwards does nothing, because by then BV
        // has already started, which is why the form used to appear only after
        // a manual refresh. So we ask BV directly when its API is on the page,
        // and otherwise load the page again with the parameters present, which
        // is the same path a refresh takes.
        function maybeOpenBvReview(data) {
            const params = data && data.bv_review_params;
            if (!params || typeof params !== "string") return;

            try {
                const incoming = new URLSearchParams(params);
                const productId =
                    incoming.get("bvproductId") || incoming.get("bvproductid") || "";
                const campaignId =
                    incoming.get("bvcampaignId") || incoming.get("bvcampaignid") || "";

                // 1) BV already loaded: drive it directly and keep the inline
                // success message on screen.
                const bv = window.$BV || window.BV;
                if (productId && bv && typeof bv.ui === "function") {
                    const opts = { productId: productId };
                    if (campaignId) opts.campaignId = campaignId;
                    bv.ui("rr", "submit_review", opts);
                    return;
                }

                // 2) Otherwise reload with the parameters in place so BV picks
                // them up as it initialises.
                const url = new URL(window.location.href);
                incoming.forEach(function (v, k) {
                    url.searchParams.set(k, v);
                });
                window.location.href = url.pathname + "?" + url.searchParams.toString();
            } catch (_) {
                // Best effort: the registration itself already succeeded and the
                // customer has been told so.
            }
        }

        form.addEventListener("submit", async function (e) {
            e.preventDefault();

            alertErr.style.display = "none";
            alertOk.style.display = "none";

            if (!validate(form)) {
                showError("Please correct the highlighted fields.");
                resetRecaptcha();
                scrollToTopSmooth();
                return;
            }

            setLoading(true);

            try {
                const formData = new FormData(form);

                if (!formData.get("shop_domain") && cfg.shopDomain) {
                    formData.set("shop_domain", cfg.shopDomain);
                }

                // Purchase location is optional. Left blank, the registration is
                // attributed to our own site: CustomerVue needs a retailer and
                // rejects the registration outright when it has no name.
                if (
                    !String(formData.get("purchase_location") || "").trim() &&
                    cfg.defaultPurchaseLocation
                ) {
                    formData.set("purchase_location", cfg.defaultPurchaseLocation);
                }

                // reCAPTCHA
                if (cfg.recaptchaEnabled) {
                    tryRenderRecaptcha();

                    if (!window.grecaptcha || window.prRecaptchaWidgetId == null) {
                        showError("reCAPTCHA is not ready. Please refresh and try again.");
                        setLoading(false);
                        scrollToTopSmooth();
                        return;
                    }

                    const token = window.grecaptcha.getResponse(window.prRecaptchaWidgetId);
                    if (!token) {
                        showError("Please complete the reCAPTCHA.");
                        setLoading(false);
                        scrollToTopSmooth();
                        return;
                    }
                    formData.set("g-recaptcha-response", token);
                }

                const payload = new URLSearchParams();
                for (const [k, v] of formData.entries()) payload.set(k, str(v));

                const res = await fetch(cfg.endpoint || form.action, {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    },
                    body: payload.toString(),
                    credentials: "same-origin",
                });

                const data = await readJsonSafely(res);

                // redirect ALWAYS wins (success OR error)
                const redirectUrl = data && (data.redirect_url || data.redirectUrl);
                if (redirectUrl && String(redirectUrl).trim() !== "") {
                    window.location.href = String(redirectUrl);
                    return;
                }

                const isOk = !!(res.ok && data && (data.success === true || data.ok === true));
                const message = data && data.message;

                if (isOk) {
                    showSuccess(message || "Thank you! Your product has been registered.");
                    resetRecaptcha();
                    form.reset();
                    alertOk.scrollIntoView({ behavior: "smooth", block: "start" });
                    restoreAddressDefaults();
                    scrollToTopSmooth();
                    maybeOpenBvReview(data);
                } else {
                    const msg =
                        (message && String(message).trim()) ||
                        `Registration failed (HTTP ${res.status}). Please contact customer care.`;

                    showError(msg);
                    resetRecaptcha();
                    alertErr.scrollIntoView({ behavior: "smooth", block: "start" });
                    scrollToTopSmooth();
                }
            } catch (err) {
                showError("Something went wrong. Please try again.");
                resetRecaptcha();
                scrollToTopSmooth();
            } finally {
                setLoading(false);
            }
        });
    }

    // =========================================================
    // Model autocomplete
    // =========================================================
    function initModelAutocomplete(root) {
        const input = qs("pr-model-input");
        const box = qs("pr-model-suggestions");
        const wrap = qs("pr-model-autocomplete");
        if (!input || !box || !wrap) return;

        const SHOP_DOMAIN = root.dataset.shop || "";
        const SEARCH_BY = root.dataset.modelSearchBy || "sku";
        const META_NS = root.dataset.modelMetaNs || "";
        const META_KEY = root.dataset.modelMetaKey || "";
        const SEARCH_ENDPOINT = root.dataset.modelSearchEndpoint || "/apps/wss/product-search";

        let activeIndex = -1;
        let items = [];
        let aborter = null;
        let debounceTimer = null;
        let lastQuery = "";

        function openBox() { box.classList.add("open"); }
        function closeBox() { box.classList.remove("open"); activeIndex = -1; }

        function setActive(idx) {
            activeIndex = idx;
            const nodes = box.querySelectorAll(".pr-suggestion");
            nodes.forEach((n, i) => n.classList.toggle("active", i === activeIndex));
        }

        function showStatus(text) {
            box.innerHTML = "";
            const div = document.createElement("div");
            div.className = "pr-suggestion is-status";
            div.textContent = text;
            box.appendChild(div);
            openBox();
        }

        function clearResults() {
            items = [];
            box.innerHTML = "";
            closeBox();
        }

        function escapeHtml(s) {
            return String(s ?? "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        function render(list) {
            items = Array.isArray(list) ? list : [];
            box.innerHTML = "";
            if (!items.length) { closeBox(); return; }

            for (let i = 0; i < items.length; i++) {
                const it = items[i];
                const div = document.createElement("div");
                div.className = "pr-suggestion";
                div.setAttribute("role", "option");
                div.dataset.index = String(i);

                const primary = it.value || it.sku || "";
                const title = it.productTitle || "";
                const variant = (it.variantTitle && it.variantTitle !== "Default Title") ? it.variantTitle : "";

                div.innerHTML = `
          <div><strong>${escapeHtml(primary)}</strong> — ${escapeHtml(title)}</div>
          ${variant ? `<small>${escapeHtml(variant)}</small>` : ""}
        `;

                div.addEventListener("mousedown", (e) => {
                    e.preventDefault();
                    input.value = it.value || it.sku || "";
                    closeBox();
                });

                box.appendChild(div);
            }

            openBox();
        }

        async function fetchSuggestions(q) {
            if (!q || q.length < 2) { clearResults(); return; }

            showStatus("Searching…");

            if (aborter) aborter.abort();
            aborter = new AbortController();

            const params = new URLSearchParams();
            params.set("q", q);
            params.set("shop_domain", SHOP_DOMAIN);
            params.set("limit", "10");
            params.set("by", SEARCH_BY);

            if (SEARCH_BY === "metafield") {
                if (META_NS) params.set("ns", META_NS);
                if (META_KEY) params.set("key", META_KEY);
            }

            try {
                const url = SEARCH_ENDPOINT + "?" + params.toString();
                const res = await fetch(url, {
                    method: "GET",
                    signal: aborter.signal,
                    headers: { Accept: "application/json" },
                });

                const txt = await res.text().catch(() => "");
                let json = {};
                try { json = JSON.parse(txt); } catch (_) {}

                const list = json.items || [];
                if (!res.ok || json.ok === false || !list.length) {
                    showStatus("No matches found.");
                    return;
                }

                render(list);
            } catch (err) {
                if (err && err.name === "AbortError") return;
                showStatus("Couldn’t load suggestions.");
            }
        }

        input.addEventListener("input", function () {
            const q = input.value.trim();
            if (q === lastQuery) return;
            lastQuery = q;

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => fetchSuggestions(q), 150);
        });

        input.addEventListener("keydown", function (e) {
            if (!box.classList.contains("open")) return;
            const max = items.length - 1;

            if (e.key === "ArrowDown") { e.preventDefault(); setActive(activeIndex < max ? activeIndex + 1 : 0); }
            else if (e.key === "ArrowUp") { e.preventDefault(); setActive(activeIndex > 0 ? activeIndex - 1 : max); }
            else if (e.key === "Enter") {
                if (activeIndex >= 0) {
                    e.preventDefault();
                    input.value = (items[activeIndex]?.value || items[activeIndex]?.sku || "");
                    closeBox();
                } else {
                    closeBox();
                }
            } else if (e.key === "Escape") { closeBox(); }
        });

        input.addEventListener("blur", function () { setTimeout(closeBox, 150); });
        document.addEventListener("click", function (e) { if (!wrap.contains(e.target)) closeBox(); });
    }
})();
